import {Component, OnInit} from '@angular/core';
import {LoaderService} from '../../services/loader.service';
import {
  Router, Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})

export class LoaderComponent implements OnInit {
  loading:boolean = true;

  constructor(private loaderService:LoaderService, private router:Router) {
    router.events.subscribe((event:RouterEvent) => {
      this.navigationInterceptor(event)
    })
  }

  ngOnInit() {
    this.loaderService.isLoading().subscribe(_isLoading => {
      this.loading = _isLoading;
    });
  }

  navigationInterceptor(event:RouterEvent):void {
    if (event instanceof NavigationStart) {
      this.loading = true
    }
    if (event instanceof NavigationEnd) {
      this.loading = false
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false
    }
    if (event instanceof NavigationError) {
      this.loading = false
    }
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/loader/loader.component.ts